import BaseLevelScene from './BaseLevelScene';

export default class MausoleumScene extends BaseLevelScene {
  tileWidth: integer = 16;
  tileHeight: integer = 16;
  name: string;
  tileMapName: string;
  tileMapPath: string;
  readyToRefresh: boolean = false;
  constructor(name: string, tilemapName:string, tileMapPath: string) {
    super(name);
    this.name = name;
    this.tileMapName = tilemapName;
    this.tileMapPath = tileMapPath;
  }

  preload() {

    // Preload base level
    this.preloadBaseLevel();

    // load the PNG files
    this.load.image('catacomb', 'assets/sourceImages/mainlevbuild.png');

    // load the JSON map
    this.load.tilemapTiledJSON(
      this.tileMapName,
      this.tileMapPath
    );
  }

  create() {
    // create the Tilemap
    this.map = this.make.tilemap({ key: this.tileMapName });

    // add the tileset image we are using (note name must match tileset in map)
    const catacombTileset = this.map.addTilesetImage('catacomb', 'catacomb');

    const allLayers = [catacombTileset];

    // // create the layers we want in the right order
    const base = this.map.createLayer('Base', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(base);

    const textures = this.map.createLayer('Textures', allLayers);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(textures);

    const furniture = this.map.createLayer('Furniture', allLayers);
    this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(furniture);

    const decorations = this.map.createLayer('Decorations', allLayers);
    // this.map.setCollisionByProperty({collides: true});
    this.matter.world.convertTilemapLayer(decorations);

    // create base level
    this.createBaseLevel(0.5, 2.5);
  }
}
